export default __webpack_public_path__ + "static/media/menu-module-current.7cadfbd9.png";